export default __webpack_public_path__ + "static/media/close-round.1ecee246.svg";